import { Component, Input } from '@angular/core';
import { DialogConfig } from 'src/app/modules/shared/components/alert-dialog/dialog-config';
import { FilePreviewType } from 'src/app/modules/shared/components/file-preview-entry/file-preview-entry.component';
import { JgLoadInspReportFile } from 'src/app/modules/shared/models/jg/jg-load-insp-report-file.model';
import { JgLoadInsp } from 'src/app/modules/shared/models/jg/jg-load-insp.model';
import { ProjectItemType } from 'src/app/modules/shared/models/project/project-item-type.enum';
import { ProjectSectionItemListRequest } from 'src/app/modules/shared/models/project/project-section-item-list-request.model';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { FileResponse } from 'src/app/modules/shared/providers/request/file-response.model';
import { JgLoadInspReportFileService } from 'src/app/modules/shared/services/jg-load-insp-report-file.service';
import { JgLoadInspService } from 'src/app/modules/shared/services/jg-load-insp.service';
import { ProjectSectionItemService } from 'src/app/modules/shared/services/project-section-item.service';

@Component({
  selector: 'app-dialog-jg-load',
  templateUrl: './dialog-jg-load.component.html',
  styleUrls: ['./dialog-jg-load.component.scss'],
})
export class DialogJgLoadComponent {
  @Input()
  data!: DialogConfig<JgLoadInsp>;

  fileType: FilePreviewType = FilePreviewType.PDF;

  editing: { [name: string]: boolean } = {};

  record: JgLoadInspReportFile = new JgLoadInspReportFile();

  fileUrls: string[] = [];

  files: FileResponse[] = [];

  dwList: {
    value: string | number;
    label: string;
    checked: boolean;
  }[] = [];

  constructor(
    private jgLoadInspService: JgLoadInspService,
    private projectSectionItemService: ProjectSectionItemService,
    private jgLoadInspReportFileService: JgLoadInspReportFileService,
    private globalService: GlobalService,
  ) {}

  ngOnInit() {
    this.record = this.data.data ?? new JgLoadInspReportFile();
    this.getDwList();
  }

  getDwList() {
    this.projectSectionItemService
      .findAll<ProjectSectionItemListRequest>({
        projectId: this.globalService.projectId,
        sectionId: this.record.sectionId,
        type: ProjectItemType.DW,
      })
      .subscribe((response) => {
        this.dwList = response
          .filter(
            (item) => item.code?.includes('Q') || item.code?.includes('X'),
          )
          .map((item) => ({
            value: item.id!,
            label: `${item.code} ${item.name}`,
            checked: false,
          }));
      });
  }

  edit(name: string) {
    this.editing[name] = true;
  }

  onBlur() {
    this.editing = {};
  }

  isNaN(content: number) {
    return window.isNaN(content);
  }

  cancel() {
    this.data.onCancel();
  }

  confirm() {
    this.submit();
  }

  onFileChange(fileResponses: FileResponse[]) {
    this.files = fileResponses;
    console.log('fileResponses', fileResponses);
    this.fileUrls = fileResponses.map((fileResponse) => fileResponse.fileId);
  }

  private handleDataBeforeConfirm(
    response: JgLoadInspReportFile,
  ): JgLoadInspReportFile {
    const data = JSON.parse(JSON.stringify(response)) as JgLoadInspReportFile;
    data.sectionItemIds = this.dwList
      .filter((item) => item.checked)
      .map((item) => `${item.value}`);
    return data;
  }

  get canConfirm() {
    if (
      this.fileUrls?.length === 0 ||
      this.record.fileSn === undefined ||
      this.record.fileSn === ''
    ) {
      return false;
    }

    return true;
  }

  private submit() {
    this.record.fileId = this.files?.[0]?.fileId;
    this.record.fileName = this.files?.[0]?.fileName;
    this.record.fileMd5 = this.files?.[0]?.fileMd5;
    this.jgLoadInspReportFileService
      .create(this.handleDataBeforeConfirm(this.record))
      .subscribe((response: JgLoadInsp) => {
        if (response) {
          this.data.onConfirm!();
        }
      });
  }
}
